import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { appActions } from "./actions";
import { AppState } from "./types";

const initialState: AppState = {
  isLoading: false,
  showModal: false,
  showContactUsModal: false,
  modalObject: null,
  showLanguageMessageModal: false,
  showLanguageSelectModal: false,
  menuDetailPopupObject: {
    // @ts-expect-error
    menu: {
      id: 0,
      name: "",
      price: 0,
      priceWithTax: 0,
      imageUrl: "",
      options: [],
      isPreorder: false,
      isEnableButton: false,
      isFavorite: false,
    },
    isLimitedMenuSelected: false,
    onClose: () => {},
    onSelectMenu: () => {},
    onFavorite: () => {},
  },
  storeDetailPopupObject: {
    name: "",
    address: "",
    phoneNumber: "",
    service: "",
    location: { lat: 0, lng: 0 },
    isFavorite: false,
    onFavorite: () => {},
    onClose: () => {},
  },
  showMenuDetailPopup: false,
  showStoreDetailPopup: false,
};

export function AppReducer(state = initialState, action: Action): AppState {
  if (isType(action, appActions.showLoading)) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (isType(action, appActions.hideLoading)) {
    return {
      ...state,
      isLoading: false,
    };
  }

  if (isType(action, appActions.showModal.done)) {
    return {
      ...state,
      showModal: true,
      modalObject: action.payload.params,
    };
  }

  if (isType(action, appActions.closeModal)) {
    return {
      ...state,
      showModal: false,
      modalObject: null,
    };
  }

  if (isType(action, appActions.showContactUsModal)) {
    return {
      ...state,
      showContactUsModal: true,
    };
  }

  if (isType(action, appActions.closeContactUsModal)) {
    return {
      ...state,
      showContactUsModal: false,
    };
  }

  if (isType(action, appActions.showLanguageMessageModal)) {
    return {
      ...state,
      showLanguageMessageModal: true,
    };
  }

  if (isType(action, appActions.closeLanguageMessageModal)) {
    return {
      ...state,
      showLanguageMessageModal: false,
    };
  }

  if (isType(action, appActions.showLanguageSelectModal)) {
    return {
      ...state,
      showLanguageSelectModal: true,
    };
  }

  if (isType(action, appActions.closeLanguageSelectModal)) {
    return {
      ...state,
      showLanguageSelectModal: false,
    };
  }

  if (isType(action, appActions.showMenuDetailPopup.done)) {
    return {
      ...state,
      showMenuDetailPopup: true,
      menuDetailPopupObject: action.payload.params,
    };
  }

  if (isType(action, appActions.closeMenuDetailPopup)) {
    return {
      ...state,
      showMenuDetailPopup: false,
      menuDetailPopupObject: {
        // @ts-expect-error
        menu: {
          id: 0,
          name: "",
          price: 0,
          priceWithTax: 0,
          imageUrl: "",
          options: [],
          isPreorder: false,
          isEnableButton: false,
          isFavorite: false,
        },
        isLimitedMenuSelected: false,
        onClose: () => {},
        onSelectMenu: () => {},
        onFavorite: () => {},
      },
    };
  }

  if (isType(action, appActions.showStoreDetailPopup.done)) {
    return {
      ...state,
      showStoreDetailPopup: true,
      storeDetailPopupObject: action.payload.params,
    };
  }

  if (isType(action, appActions.closeStoreDetailPopup)) {
    return {
      ...state,
      showStoreDetailPopup: false,
      storeDetailPopupObject: {
        name: "",
        address: "",
        phoneNumber: "",
        service: "",
        location: { lat: 0, lng: 0 },
        isFavorite: false,
        onFavorite: () => {},
        onClose: () => {},
      },
    };
  }

  if (isType(action, appActions.setMenuDetailPopupFavorite)) {
    return {
      ...state,
      menuDetailPopupObject: {
        ...state.menuDetailPopupObject,
        menu: {
          ...state.menuDetailPopupObject.menu,
          isFavorite: action.payload,
        },
      },
    };
  }

  if (isType(action, appActions.setStoreDetailPopupFavorite)) {
    return {
      ...state,
      storeDetailPopupObject: {
        ...state.storeDetailPopupObject,
        isFavorite: action.payload,
      },
    };
  }

  if (isType(action, appActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
